import React, { useEffect, useState } from "react";
import ConfirmationModal from "../ConfirmationModal";
import Modal, { ModalProps } from "../index";
import { ConfirmationContent, MainContainer } from "../ModalStyledComponents";
import Content from "./Content";
import Footer from "./Footer";
import Header from "./Header";
import useInputState from "../../calendar/inputState/useInputState";
import { useDispatch, useSelector } from "../../store/store";
import {
    getCalendarData,
    getOriginalData,
    isDirty,
    resetData,
    showChangeList,
} from "../../store/data";
import { useTranslation } from "react-i18next";
import useCalendar from "../../calendar/context/useCalendar";
import ChangeList from "./ChangeList";

interface Props extends ModalProps {
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ConsultationModal = ({ open, setOpen }: Props) => {
    const { inputCallbacks } = useCalendar();
    const dispatch = useDispatch();
    const dirty = useSelector(isDirty);
    const inChangeList = useSelector(showChangeList);

    const { t } = useTranslation();

    const { isRegular: isRegularByDefault, version } = useInputState();
    const [isRegular, setIsRegular] = useState(isRegularByDefault);

    useEffect(() => {
        setIsRegular(isRegularByDefault);
    }, [isRegularByDefault, version]);

    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

    const handleConfirm = () => {
        dispatch(resetData());

        setOpen(false);

        inputCallbacks.onChangeConsultationClose &&
            inputCallbacks.onChangeConsultationClose();
    };

    const handleClose = () => {
        if (dirty) {
            setIsConfirmationOpen(true);
        } else {
            setOpen(false);
            inputCallbacks.onChangeConsultationClose &&
                inputCallbacks.onChangeConsultationClose();
        }
    };

    const handleCancel = () => {
        setIsConfirmationOpen(false);
        setOpen(true);
    };

    return (
        <>
            {!isConfirmationOpen ? (
                <Modal open={open} onClose={handleClose}>
                    <MainContainer style={{ width: "90vw" }}>
                        {inChangeList ? (
                            <>
                                <ChangeList closeModal={() => setOpen(false)} />
                            </>
                        ) : (
                            <>
                                <Header
                                    isRegular={isRegular}
                                    setIsRegular={setIsRegular}
                                />
                                <Content isRegular={isRegular} />
                                <Footer
                                    closeModal={() => setOpen(false)}
                                    isRegular={isRegular}
                                />
                            </>
                        )}
                    </MainContainer>
                </Modal>
            ) : (
                <ConfirmationModal
                    open={isConfirmationOpen}
                    onClose={handleClose}
                    onConfirm={handleConfirm}
                    onCancel={handleCancel}
                    title={`${t("sure_close")} ?`}
                    cancelLabel={t("back")}
                    confirmLabel={t("close")}
                >
                    <ConfirmationContent>
                        {t("unsaved_data_loss")}
                    </ConfirmationContent>
                </ConfirmationModal>
            )}
        </>
    );
};

export default ConsultationModal;
